'use strict';

/**
 * Pict-Provider-CommentAPI
 * ------------------------
 * Browser-side CRUD client for the Comment entity, extending the generic EntityAPI provider. The one
 * extra helper is listForThread: the comments in a thread, oldest first (the section re-orders for
 * display). Tenancy (IDCustomer) is enforced server-side.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'CommentAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'Comment',
	PluralRoute: 'Comments',
	IDField: 'IDComment'
};

class PictProviderCommentAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The comments in a thread.
	 * @param {number} pIDCommentThread
	 * @returns {Promise<Array<object>>}
	 */
	listForThread(pIDCommentThread)
	{
		let tmpFilter = 'FBV~IDCommentThread~EQ~' + pIDCommentThread;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/500'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.catch(() => []);
	}
}

module.exports = PictProviderCommentAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
